import type { OrderStatusModel } from '@merchant-clients/order';

export const orderNextStatusMap = new Map<OrderStatusModel, OrderStatusModel>([
  ['PENDING', 'CONFIRMED'],
  ['CONFIRMED', 'READY'],
  ['READY', 'CLOSED'],
]);
